import { styleConstants } from '@paywithextend/components'
import React from 'react'
import { UpdateVirtualCardScreen } from 'src/app/UpdateVirtualCardForm/UpdateVirtualCardForm'
import ActionRightFlyoutContent from 'src/components/ActionRightFlyoutContent/ActionRightFlyoutContent'
import ChooseObjectTypeBox from 'src/components/ChooseObjectTypeBox/ChooseObjectTypeBox'
import { ImageNames } from 'src/enums'
import { useColorOrGrayscaleImage } from 'src/hooks/brandHooks'
import Trns from 'src/localization/Trns'
import { VirtualCardSecureModel } from 'src/models/virtualCard.models'
import { VirtualCardPermissionsModel } from 'src/models/virtualCardPermissions.models'
import styled from 'styled-components'

interface UpdateVirtualCardPickContentProps {
  className?: string
  id: string
  setScreen: (val: UpdateVirtualCardScreen) => void
  standardDisabled?: boolean
  recurringDisabled?: boolean
  virtualCard: VirtualCardSecureModel
  virtualCardPermissions: VirtualCardPermissionsModel
  hideRecurring: boolean
}

const ChooseUpdateObjectTypeBox = styled(ChooseObjectTypeBox)`
  &:nth-child(n + 2) {
    margin-top: ${styleConstants.heights.minorInternalGutter};
  }
`

const UpdateVirtualCardPickContent: React.FC<
  UpdateVirtualCardPickContentProps
> = (props) => {
  const cardTypeStandardImage = useColorOrGrayscaleImage(
    ImageNames.CardTypeStandard,
  )
  const cardTypeRecurringImage = useColorOrGrayscaleImage(
    ImageNames.CardTypeRecurring,
  )
  return (
    <ActionRightFlyoutContent
      title={props.virtualCard.updateFlyoutTitle(props.virtualCardPermissions)}
      pickerSubtitle={
        <Trns
          source={
            'Change the card type to what is needed. Note that changing the type will affect what form fields you see.'
          }
        />
      }
      permissions={{
        canUpdateVirtualCard:
          props.virtualCardPermissions.canUpdateVirtualCard &&
          !props.virtualCard.isConsumed,
      }}
    >
      <ChooseUpdateObjectTypeBox
        imageSrc={cardTypeStandardImage}
        title={<Trns source={'Standard Card'} />}
        subtitle={
          props.virtualCardPermissions.canUpdateVirtualCard ? (
            <Trns
              source={
                'Create a basic virtual card with all the set controls you need to securely send a company card.'
              }
            />
          ) : (
            <Trns
              source={
                'The most common option. Use it for day-to-day expenses, or just once. You can receive or request future updates when needed.'
              }
            />
          )
        }
        onClick={(): void => {
          props.setScreen(UpdateVirtualCardScreen.Standard)
        }}
        disabled={props.standardDisabled}
      />
      {!props.hideRecurring && (
        <ChooseUpdateObjectTypeBox
          imageSrc={cardTypeRecurringImage}
          title={<Trns source={'Recurring Card'} />}
          subtitle={
            props.virtualCardPermissions.canUpdateVirtualCard ? (
              <Trns
                source={
                  'Set up a card for recurring expenses at a set frequency, such as monthly or weekly subscriptions.'
                }
              />
            ) : (
              <Trns
                source={
                  'Have a recurring expense? This virtual card will reset its spend limit at a daily, weekly or monthly frequency.'
                }
              />
            )
          }
          onClick={(): void => {
            props.setScreen(UpdateVirtualCardScreen.Recurring)
          }}
          disabled={props.recurringDisabled}
        />
      )}
    </ActionRightFlyoutContent>
  )
}

export default UpdateVirtualCardPickContent
